import { useState, useCallback } from "react";
import axios from "axios";
import { BASE_URL } from "../../../utils/config/config";
import { DEFAULT_ERROR_MESSAGE } from "./ForgotPassword.constants";

export const useForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorState, setErrorState] = useState({ error: false, message: "" });

  const handleSubmit = useCallback(async () => {
    try {
      setLoading(true);
      setErrorState({ error: false, message: "" });
      const response = await axios.post(`${BASE_URL}user/forget-password`, {
        email: email.toLowerCase().trim(),
      });

      if (response.status === 200) {
        setSuccess(true);
      }
    } catch (error) {
      console.error("Error sending password reset email:", error);
      setErrorState({
        error: true,
        message:
          error?.response?.data?.message || DEFAULT_ERROR_MESSAGE,
      });
    } finally {
      setLoading(false);
    }
  }, [email]);

  const closeSuccess = useCallback(() => setSuccess(false), []);
  const closeError = useCallback(
    () => setErrorState({ error: false, message: "" }),
    []
  );

  return {
    email,
    setEmail,
    loading,
    success,
    errorState,
    handleSubmit,
    closeSuccess,
    closeError,
  };
};
